export enum DeviceDatapoint {
  CONNECTED = 'connected',
}
